import { BetTransactionStatusType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const betTransactionStatusName: { [key in BetTransactionStatusType]: TKeyType } = {
  [BetTransactionStatusType.UNSETTLEMENT]: 'transactionStatus.unsettlement',
  [BetTransactionStatusType.SETTLEMENT]: 'transactionStatus.settlement'
}

export default betTransactionStatusName
